export function H1({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h1 className={`mb-4 text-2xl ${className ?? ""}`}>{children}</h1>;
}
